/**
 * equasion-lib's .d.ts types `Button` without `onClick` and `Input` with every prop required
 * (inputType, defaultValue, icons…), although both forward the rest to the DOM element at runtime.
 * Spreading an untyped bag — the same trick SalesOrderSummary uses for its Option-2 buttons —
 * keeps these new screens from adding to the app's standing TS2322 baseline without casting the
 * components themselves.
 */
export const eqProps = (props: Record<string, unknown>): any => props;
